module.exports = __webpack_public_path__ + "static/media/icon_send_off.5f2aa508.png";